import { HTMLAttributes } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: JSX.Element[] | JSX.Element;
  text: string;
}

function MouseOver(props: Props): JSX.Element {
  /* Define state / hook */

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <OverlayTrigger
      overlay={
        <Tooltip id="button-tooltip-2">
          <h6>{props.text}</h6>
        </Tooltip>
      }
      placement="top-start"
    >
      <div className={props.className}>{props.children}</div>
    </OverlayTrigger>
  );
}

export default MouseOver;
